<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <v-container>
        <v-row align="center">
          <v-col cols="3">
            <div class="text-h5 font-weight-bold">Evaluaciones</div>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3">
            <v-select
              label="Filtrar evaluaciones"
              v-model="filtroEstatus"
              :items="filteredEstatusEvaluacion"
              item-value="title"
              item-text="title"
              item-color="secondary"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="selectedTab" color="secondary">
        <v-tab v-for="(label, key) in EVALUACIONES" :key="key" :tab-value="EVALUACIONES[key]">
          {{ label }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item v-for="(label, key) in EVALUACIONES" :key="key" :value="EVALUACIONES[key]">
          <EvaluacionesDesempenioTable
            :evaluaciones="evaluationsToDisplay"
            @edit-evaluation="openEditEvaluationModal"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <EvaluacionesDialogs :activeDialog="activeDialog" :evaluacion="selectedEvaluation" @close="activeDialog = ''" />
    <evaluacion-respeto-principios-dialog-component
      :active="respetoPrincipiosDialog"
      @close="respetoPrincipiosDialog = false"
      :respeto-principios="respetoPrincipios"
    ></evaluacion-respeto-principios-dialog-component>
    <evaluacion-anual-dialog-component
      :active="evaluacionAnualDialog"
      @close="evaluacionAnualDialog = false"
      :evaluacion-anual="evaluacionAnual"
    ></evaluacion-anual-dialog-component>
  </v-card>
</template>
<script>
import EvaluacionRespetoPrincipiosDialogComponent from '../../components/desarrollo_policial/EvaluacionRespetoPrincipiosDialogComponent.vue'
import EvaluacionProductividadDialogComponent from '../../components/desarrollo_policial/EvaluacionProductividadDialogComponent.vue'
import EvaluacionAnualDialogComponent from '../desarrollo_policial/EvaluacionAnualDialogComponent.vue'
import EvaluacionRespetoPrincipiosValoresDialogComponent from '../../components/desarrollo_policial/EvaluacionRespetoPrincipiosValoresDialogComponent.vue'
import EvaluacionDesempenioInstitucionalDialogComponent from '../../components/desarrollo_policial/EvaluacionDesempenioInstitucionalDialogComponent.vue'
import EvaluacionRendimientoProfesionalismoDialogComponent from '../../components/desarrollo_policial/EvaluacionRendimientoProfesionalismoDialogComponent.vue'
import { mapActions, mapGetters } from 'vuex'
import EvaluacionesDesempenioTable from './evaluaciones/EvaluacionesDesempenioTable.vue'
import EvaluacionesDialogs from '@src/components/desarrollo_policial/evaluacion-desempeño/dialogs/EvaluacionesDialogs.vue'

const EVALUACIONES = {
  PRODUCTIVIDAD: 'Productividad',
  RESPETO_PRINCIPIOS: 'Respeto a los principios',
  EVALUACION_ANUAL: 'Evaluacion anual',
}

export default {
  components: {
    EvaluacionRespetoPrincipiosDialogComponent,
    EvaluacionProductividadDialogComponent,
    EvaluacionAnualDialogComponent,
    EvaluacionRespetoPrincipiosValoresDialogComponent,
    EvaluacionDesempenioInstitucionalDialogComponent,
    EvaluacionRendimientoProfesionalismoDialogComponent,
    EvaluacionesDesempenioTable,
    EvaluacionesDialogs,
  },

  props: {
    personal: {
      type: Object,
    },

    evaluaciones: {
      type: Object,
    },
  },

  data() {
    return {
      respetoPrincipiosDialog: false,
      selectedRespetoPrincipios: null,

      productividadDialog: false,

      evaluacionAnualDialog: false,

      selectedDesempeñoInstitucional: null,
      desempeñoInstitucionalDialog: false,

      selectedRendimientoProfesionalismo: null,
      rendimientoProfesionalismoDialog: false,

      selectedRespetoPrincipiosValores: null,
      respetoPrincipiosValoresDialog: false,

      filtroEstatus: 'Evaluación Pendiente',

      EVALUACIONES,
      selectedTab: EVALUACIONES.PRODUCTIVIDAD,
      selectedEvaluation: null,
      activeDialog: '',
    }
  },

  computed: {
    ...mapGetters('respetoPrincipios', {
      respetoPrincipios: 'getRespetoPrincipiosSingle',
    }),

    ...mapGetters('productividad', {
      productividad: 'getProductividadSingle',
    }),

    ...mapGetters('evaluacionAnual', {
      evaluacionAnual: 'getEvaluacionAnualSingle',
    }),

    ...mapGetters('reactivoPrincipio', {
      reactivos: 'getReactivoPrincipio',
    }),

    ...mapGetters('indicadorEvaluacion', {
      indicadores: 'getIndicadorEvaluacion',
    }),

    ...mapGetters('actosRelevantesEvaluacion', {
      actosRelevantes: 'getActosRelevantesEvaluacion',
    }),

    ...mapGetters('descripcionCriterio', {
      descripcionCriterio: 'getDescripcionCriterio',
    }),

    ...mapGetters('valoresCapacidades', {
      valoresCapacidades: 'getValoresCapacidades',
    }),

    ...mapGetters('principiosConstitucionales', {
      principiosConstitucionales: 'getPrincipiosConstitucionales',
    }),

    ...mapGetters('estatusEvaluacion', {
      estatusEvaluacion: 'getEstatusEvaluacion',
    }),

    ...mapGetters('reactivosEvaluacion', {
      reactivosDesempenioInstitucional: 'getReactivosDesempenioInstitucional',
      reactivosRendimientoProfesionalismo: 'getReactivosRendimientoProfesionalismo',
    }),

    ...mapGetters('desempeñoInstitucional', {
      desempeñoInstitucionalPersonal: 'getDesempeñoInstitucionalPersonal',
    }),

    ...mapGetters('rendimientoProfesionalismo', {
      rendimientoProfesionalismoPersonal: 'getRendimientoProfesionalismoPersonal',
    }),

    ...mapGetters('respetoPrincipiosValores', {
      respetoPrincipiosValoresPersonal: 'getRespetoPrincipiosValoresPersonal',
    }),

    getEstatusText() {
      if (this.filtroEstatus == 1) {
        return 'pendientes'
      } else return 'finalizadas'
    },

    filteredEstatusEvaluacion() {
      return this.estatusEvaluacion.filter((estatus) => {
        return estatus.id != 2
      })
    },

    filteredProductividad() {
      if (this.evaluaciones.Productividad) {
        return this.evaluaciones.Productividad.filter((evaluacion) => {
          return evaluacion.estatusEvaluacion === this.filtroEstatus
        })
      }
    },

    filteredRespetoPrincipios() {
      if (this.evaluaciones.RespetoPrincipios) {
        return this.evaluaciones.RespetoPrincipios.filter((evaluacion) => {
          return evaluacion.estatusEvaluacion === this.filtroEstatus
        })
      }
    },

    filteredDesmpeñoInstitucional() {
      if (this.evaluaciones.DesempeñoInstitucional) {
        return this.evaluaciones.DesempeñoInstitucional.filter((evaluacion) => {
          return evaluacion.estatusEvaluacion === this.filtroEstatus
        })
      }
    },

    filteredRendimientoProfesionalismo() {
      if (this.evaluaciones.RendimientoProfesionalismo) {
        return this.evaluaciones.RendimientoProfesionalismo.filter((evaluacion) => {
          return evaluacion.estatusEvaluacion === this.filtroEstatus
        })
      }
    },

    filteredRespetoPrincipiosValores() {
      if (this.evaluaciones.RespetoPrincipiosValores) {
        return this.evaluaciones.RespetoPrincipiosValores.filter((evaluacion) => {
          return evaluacion.estatusEvaluacion === this.filtroEstatus
        })
      }
    },

    filteredEvaluacionesAnuales() {
      if (this.evaluaciones.EvaluacionAnual) {
        return this.evaluaciones.EvaluacionAnual.filter((evaluacion) => {
          return evaluacion.estatusEvaluacion === this.filtroEstatus
        })
      }
    },

    evaluationsToDisplay() {
      switch (this.selectedTab) {
        case EVALUACIONES.PRODUCTIVIDAD:
          return this.filteredProductividad
        case EVALUACIONES.RESPETO_PRINCIPIOS:
          return this.filteredRespetoPrincipios
        case EVALUACIONES.EVALUACION_ANUAL:
          return this.filteredEvaluacionesAnuales
        case EVALUACIONES.DESEMPEÑO_INSTITUCIONAL:
          return this.filteredDesmpeñoInstitucional
        case EVALUACIONES.RENDIMIENTO_PROFESIONALISMO:
          return this.filteredRendimientoProfesionalismo
        case EVALUACIONES.RESPETO_PRINCIPIOS_VALORES:
          return this.filteredRespetoPrincipiosValores
        default:
          return []
      }
    },
  },

  methods: {
    ...mapActions('productividad', ['fetchProductividadById']),
    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipiosById']),

    ...mapActions('desempeñoInstitucional', ['fetchDesempeñoInstitucionalById']),
    ...mapActions('rendimientoProfesionalismo', ['fetchRendimientoProfesionalismoById']),
    ...mapActions('respetoPrincipiosValores', ['fetchRespetoPrincipiosValoresById']),
    ...mapActions('evaluacionAnual', ['fetchEvaluacionAnualById']),
    ...mapActions('descripcionCriterio', ['fetchDescripcionCriterio']),

    async evaluacionRespetoPrincipios(respetoPrincipios) {
      await this.fetchRespetoPrincipiosById(respetoPrincipios)

      this.selectedRespetoPrincipios = this.respetoPrincipios
      this.respetoPrincipiosDialog = true
    },

    async evaluacionProductividad(productividad) {
      await this.fetchProductividadById(productividad)
      this.selectedEvaluation = this.productividad
      this.activeDialog = 'productividad'
    },

    async openEvaluacionAnual(evaluacionAnual) {
      await this.fetchEvaluacionAnualById(evaluacionAnual)
      await this.fetchDescripcionCriterio(this.evaluacionAnual.fk_idCatTipoEvaluacion)
      this.descripcionCriterio.forEach((descripcion) => {
        this.evaluacionAnual.cumplimientoFunciones.push({
          calificacion: '',
          fk_idDescripcionCriterio: descripcion.id,
          estatus: true,
        })
      })
      this.valoresCapacidades.forEach((valor) => {
        this.evaluacionAnual.evaluacionValores.push({
          calificacion: '',
          fk_idCatValoresCapacidad: valor.id,
          estatus: true,
        })
      })
      this.principiosConstitucionales.forEach((principio) => {
        this.evaluacionAnual.evaluacionPrincipios.push({
          calificacion: '',
          fk_idCatPrincipiosConstitucionales: principio.id,
          estatus: true,
        })
      })
      this.principiosConstitucionales.forEach((habilidad) => {
        this.evaluacionAnual.evaluacionHabilidades.push({
          calificacion: '',
          fk_idCatHabilidades: habilidad.id,
          estatus: true,
        })
      })
      this.evaluacionAnualDialog = true
    },

    async openDesempeñoInstitucionalDialog(evaluacion) {
      await this.fetchDesempeñoInstitucionalById(evaluacion)
      this.reactivosDesempenioInstitucional.forEach((reactivo) => {
        this.desempeñoInstitucionalPersonal.frecuenciasMedicion.push({
          fk_idCatFrecuencia: null,
          fk_idReactivoEvaluacion: reactivo.id,
          estatus: true,
        })
      })
      this.selectedDesempeñoInstitucional = this.desempeñoInstitucionalPersonal
      this.desempeñoInstitucionalDialog = true
    },

    async openRendimientoProfesionalismoDialog(evaluacion) {
      await this.fetchRendimientoProfesionalismoById(evaluacion)

      this.reactivosRendimientoProfesionalismo.forEach((reactivo) => {
        this.rendimientoProfesionalismoPersonal.frecuenciasMedicion.push({
          fk_idCatFrecuencia: null,
          fk_idReactivoEvaluacion: reactivo.id,
          estatus: true,
        })
      })

      this.selectedRendimientoProfesionalismo = this.rendimientoProfesionalismoPersonal
      this.rendimientoProfesionalismoDialog = true
    },

    async openRespetoPrincipiosValoresDialog(evaluacion) {
      await this.fetchRespetoPrincipiosValoresById(evaluacion)

      this.reactivos.forEach((reactivo) => {
        this.respetoPrincipiosValoresPersonal.frecuenciasMedicion.push({
          fk_idCatFrecuencia: null,
          fk_idReactivoValor: reactivo.id,
          estatus: true,
        })
      })

      this.selectedRespetoPrincipiosValores = this.respetoPrincipiosValoresPersonal
      this.respetoPrincipiosValoresDialog = true
    },

    getFullName(person) {
      if (person.segundoNombre == '') {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.Nombre
      } else {
        return person.apaterno + ' ' + person.amaterno + ' ' + person.Nombre + ' ' + person.segundoNombre
      }
    },

    openEditEvaluationModal(evaluation) {
      switch (this.selectedTab) {
        case EVALUACIONES.PRODUCTIVIDAD:
          this.evaluacionProductividad(evaluation)
          break
        case EVALUACIONES.RESPETO_PRINCIPIOS:
          this.evaluacionRespetoPrincipios(evaluation)
          break
        case EVALUACIONES.EVALUACION_ANUAL:
          this.openEvaluacionAnual(evaluation)
          break
        default:
          break
      }
    },
  },
}
</script>
